export interface TellentPosition {
  guid: string;
  members: TellentPositionMember[];
  membersCount: number;
  name: string;
  descriptionHtml?: string | null;
  descriptionJson?: unknown | null;
}

export interface TellentPositionMember {
  assignedAt: string;
  avatarThumbUrl: string | null;
  email: string;
  firstName: string;
  guid: string;
  hasWorkEmail: boolean;
  lastName: string;
  login: string | null;
}

export interface TellentPositionResponse {
  data: TellentPosition;
}

export interface PositionDetailsDialogData {
  positionGuid: string;
}

export interface UpdatePositionPayload {
  name?: string;
  descriptionJson?: unknown | null;
}

export interface DeletePositionDialogData {
  position: TellentPosition;
}

export interface DeletePositionDialogResult {
  success: boolean;
}

export interface RenamePositionDialogData {
  positionGuid: string;
}

export interface RenamePositionDialogResult {
  success: boolean;
}

export interface PositionMemberConflict {
  member: TellentPositionMember;
  currentPosition: TellentPosition;
}

export interface ReassignMemberWarningDialogData {
  targetPositionName: string;
  members: PositionMemberConflict[];
}

export interface ReassignMemberWarningDialogResult {
  confirmed: boolean;
}

export interface UnassignMemberFromPositionDialogResult {
  success: boolean;
}

export enum PositionDetailsTab {
  Employees = 'employees',
  Description = 'description',
  Skills = 'skills',
}
